import React from 'react';

export function useConfirmationDialog() {
  const [isOpen, setIsOpen] = React.useState(false);

  function open() {
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  return { close, isOpen, open };
}
